export const JACAR_API_URL = "https://jacar.co.kr/";
export const VERSION = "v1.0";
export const HOST_CENTER_ID = "6158167248";
